"use client";

import React from "react";

interface BookingModalProps {
	children?: React.ReactNode;
	triggerText?: string;
	className?: string;
}

export default function BookingModal({
	children,
	triggerText = "Termin buchen",
	className = "",
}: BookingModalProps) {
	const openTermin365 = () => {
		console.log("Redirecting to Termin365...");

		// Track GA4 event
		if (typeof (window as any).gtag === "function") {
			(window as any).gtag("event", "booking_click", {
				event_category: "conversion",
				event_label: "Termin365 Booking",
				value: 1,
			});
		}

		window.open("https://stelladent.termin365.at", "_blank");
	};

	return (
		<>
			{/* Trigger Button */}
			{children ? (
				<div
					onClick={openTermin365}
					className="cursor-pointer"
				>
					{children}
				</div>
			) : (
				<button
					onClick={openTermin365}
					className={`cursor-pointer inline-flex items-center justify-center ${className}`}
				>
					<span>{triggerText}</span>
				</button>
			)}
		</>
	);
}
